module.exports = __webpack_public_path__ + "img/ticket_btn.506d73ce.png";